module.exports = __webpack_public_path__ + "static/media/king-on-africa.2580fec4.jpg";